import { styled } from '@mui/material';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { useMediaQuery } from "@mui/material"
import theme from '../../styles/theme';

export default function MyChip({setOpenSearch,setChipTitle}) {
  const matches = useMediaQuery(theme.breakpoints.down("md"))

  const handleClick = (keyword) => {
    setOpenSearch(true)
    setChipTitle(keyword)
  }

  return (
    <Stack direction="row" spacing={2} flexWrap="wrap">
      <Chip label="#淫妻" color='primary' variant='outlined' size='small' onClick={()=>{
        handleClick("淫妻")
      }} style={{
        margin:"0px 10px 10px 0"
      }}/>
      <Chip label="#夜未央" color='primary' variant='outlined' size='small' onClick={()=>{
        handleClick("夜未央")
      }} style={{
        margin:"0px 10px 10px 0"
      }}/>
      <Chip label="#换妻" color='primary' variant='outlined' size='small' onClick={()=>{
        handleClick("换妻")
      }} style={{
        margin:"0px 10px 10px 0"
      }}/>
      <Chip label="#群P" color='primary' variant='outlined' size='small' onClick={()=>{
        handleClick("群P")
      }} style={{
        margin:"0px 10px 10px 0"
      }}/>
      <Chip label="#媚黑" color='primary' variant='outlined' size='small' onClick={()=>{
        handleClick("媚黑")
      }} style={{
        margin:"0px 10px 10px 0"
      }}/>
      <Chip label="#熟女" color='primary' variant='outlined' size='small' onClick={()=>{
        handleClick("熟女")
      }} style={{
        margin:"0px 10px 10px 0"
      }}/>
      <Chip label="#内射" color='primary' variant='outlined' size='small' onClick={()=>{
        handleClick("内射")
      }} style={{
        margin:"0px 10px 10px 0"
      }}/>
      <Chip label="#双龙入洞" color='primary' variant='outlined' size='small' onClick={()=>{
        handleClick("双龙入洞")
      }} style={{
        margin:"0px 10px 10px 0"
      }}/>
      <Chip label="#露出" color='primary' variant='outlined' size='small' onClick={()=>{
        handleClick("内射")
      }} style={{
        margin:"0px 10px 10px 0"
      }}/>
      <Chip label="#露出" color='primary' variant='outlined' size='small' onClick={()=>{
        handleClick("露出")
      }} style={{
        margin:"0px 10px 10px 0"
      }}/>
      <Chip label="#调教" color='primary' variant='outlined' size='small' onClick={()=>{
        handleClick("调教")
      }} style={{
        margin:"0px 10px 10px 0"
      }}/>
      <Chip label="#御姐" color='primary' variant='outlined' size='small' onClick={()=>{
        handleClick("御姐")
      }} style={{
        margin:"0px 10px 10px 0"
      }}/>  
      <Chip label="#少妇" color='primary' variant='outlined' size='small' onClick={()=>{
        handleClick("少妇")
      }} style={{
        margin:"0px 10px 10px 0"
      }}/>
     
    </Stack>
  );
}